module.exports = __webpack_public_path__ + "assets/img/1408.jpg?0b923312381bbcd9c4299dcc8c40be4b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1408.jpg
// module id = 1077
// module chunks = 0